export function csvEscape (value) {
  if (value === null || value === undefined) return '""'
  const s = String(value)
  return '"' + s.replace(/"/g, '""') + '"'
}

function fmtCell (value) {
  if (value === null || value === undefined || value === '') return ''
  const n = Number(value)
  if (Number.isFinite(n) && n === 0) return ''
  return value
}

export function formatDarabarDisplay (value) {
  const cell = fmtCell(value)
  if (cell === '') return ''
  return `${cell}/db`
}

function shouldIncludeMegmunkalasRow (page) {
  if (!page.megmunkalasid || page.blockType === 'megmunkalas') return false
  const fm = Number(page.osszfm) || 0
  const ar = Number(page.megmunkalas_ar) || 0
  const name = (page.megmunkalasName || '').toString().trim()
  return fm > 0 || ar > 0 || name.length > 0
}

export function shouldShowBlockTotalRow (page) {
  return !!(page.megmunkalasid && page.blockType !== 'megmunkalas')
}

export function blockPageOsszeg (page) {
  return (Number(page.pageAr) || 0) + (Number(page.megmunkalas_ar) || 0)
}

/**
 * 8 oszlop: Megnevezés, db, cm(x), cm(y), m2, fm, Anyag+kivitel, Ár
 */
export function calculatorUiToCsv (client, sep = ';') {
  const lines = []

  const status =
    (client.statusid && client.statusid.megnevezes) ||
    client.status ||
    client.statusnev ||
    ''

  const headerPairs = [
    ['Státusz', status],
    ['Partner kat.', client.partnerkategoria || ''],
    ['MiniCRM adatlap neve', client.partner || ''],
    ['MiniCRM adatlap link', client.emaillink || ''],
    ['Megjegyzés', client.megjegyzes || '']
  ]
  headerPairs.forEach(([k, v]) => {
    lines.push([k, v].map(csvEscape).join(sep))
  })

  lines.push('')
  lines.push(['Megnevezés', 'db', 'cm(x)', 'cm(y)', 'm2', 'fm', 'Anyag+kivitel', 'Ár'].map(csvEscape).join(sep))

  ;(client.pages || []).forEach(page => {
    ;(page.tetels || []).forEach(t => {
      lines.push([
        t.tetelnev || '',
        t.db || '',
        t.cm1 || '',
        t.cm2 || '',
        t.m2 || '',
        fmtCell(t.fm),
        '',
        formatDarabarDisplay(t.darabar)
      ].map(csvEscape).join(sep))
    })

    lines.push([
      '',
      '',
      '',
      '',
      page.osszterulet || '',
      '',
      page.tipusName || '',
      page.pageAr || ''
    ].map(csvEscape).join(sep))

    if (shouldIncludeMegmunkalasRow(page)) {
      lines.push([
        '',
        '',
        '',
        '',
        '',
        fmtCell(page.osszfm),
        page.megmunkalasName || '',
        fmtCell(page.megmunkalas_ar)
      ].map(csvEscape).join(sep))
    }

    if (shouldShowBlockTotalRow(page)) {
      lines.push(['', '', '', '', '', '', '', blockPageOsszeg(page)].map(csvEscape).join(sep))
    }

    lines.push('')
  })

  ;(client.cikkTetels || []).forEach(t => {
    const nettoOssz = (t.netto !== undefined && t.db !== undefined)
      ? (Number(t.netto) * Number(t.db))
      : ''
    lines.push([
      t.megnevezes || '',
      t.db || '',
      '',
      '',
      '',
      '',
      t.mennyisegiegyseg || '',
      nettoOssz
    ].map(csvEscape).join(sep))
  })

  if (client.szamitottVegOsszeg !== undefined && client.szamitottVegOsszeg !== null) {
    lines.push(['Számított végösszeg', '', '', '', '', '', '', client.szamitottVegOsszeg].map(csvEscape).join(sep))
  }
  if (client.VegOsszeg !== undefined && client.VegOsszeg !== null) {
    lines.push(['Kiajánlott ár', '', '', '', '', '', '', client.VegOsszeg].map(csvEscape).join(sep))
  }

  return lines.join('\n')
}



// WEBPACK FOOTER //
// ./src/utils/munkalapCsvExport.js